import { ChapterSection } from "../ServicesMenuChapter.interface";
import { motion } from "framer-motion";
import SectionHeader, { SectionHeaderProps } from "../components/SectionHeader";
import TextWrapper from "./TextWrapper";
import VariantWrapper from "./VariantWrapper";
import SectionMedia from "./SectionMedia";
import {
    CAROUSEL_ITEM_HEADER_HEIGHT,
    CAROUSEL_ITEM_MEDIA_WIDTH,
    CAROUSEL_ITEM_PADDING
} from "./SectionLayout.constants";
import { GradualSpacing } from '../../../effects/GradualSpacing';
import { NIKE_EASE } from '../../../../rise/constants/nikerise';
import { DEFAULT_TRANSITION_DURATION } from '../ServiceMenuChapter.constants';

interface EntrySectionLayoutProps {
    section: ChapterSection,
    headerSettings: SectionHeaderProps,
    isEntrySection: boolean,
}

const CAROUSEL_VARIANT_1_SETTINGS = {
    mediaHeight: 69.58 // 1336px
}

function SectionLayoutVariant1(props: EntrySectionLayoutProps) {
    const {
        headerSettings,
        section,
        isEntrySection,
    } = props;
    const {
        media,
        title,
        description,
    } = section;

    return (
        <VariantWrapper section={section}>
            <SectionHeader {...headerSettings} />

            <TextWrapper
                style={{
                    padding: `4.17vh ${CAROUSEL_ITEM_PADDING}vh`, // 80px 50px
                    top: `${CAROUSEL_ITEM_HEADER_HEIGHT}vh`,
                    left: 0,
                    fontFamily: 'HelveticaNowDisplay',
                    fontWeight: '500',
                    fontSize: '5vh', // 96px
                    lineHeight: '5.5vh', // 105.60px
                    textTransform: 'uppercase',
                }}
            >
                <GradualSpacing text={title} offset={1} />
            </TextWrapper>

            <TextWrapper
                style={{
                    padding: `${CAROUSEL_ITEM_PADDING}vh`,
                    bottom: `calc(${CAROUSEL_VARIANT_1_SETTINGS.mediaHeight}vh + ${CAROUSEL_ITEM_PADDING}vh)`,
                    right: 0,
                    fontSize: '1.67vh', // 32px
                    fontFamily: 'HelveticaNowText',
                    fontWeight: '400',
                    lineHeight: '2.17vh', // 41.60px
                }}
                initial
            >
                {description}
            </TextWrapper>

            <motion.div
                style={{
                    position: 'absolute',
                    zIndex: 200,
                }}
                initial={isEntrySection ? {
                    width: '100vw',
                    height: '100vh',
                    x: 0,
                    y: 0,
                } : false}
                animate={{
                    width: `${CAROUSEL_ITEM_MEDIA_WIDTH}vh`,
                    height: `${CAROUSEL_VARIANT_1_SETTINGS.mediaHeight}vh`,
                    x: `${CAROUSEL_ITEM_PADDING}vh`,
                    y: `calc(100vh - ${CAROUSEL_VARIANT_1_SETTINGS.mediaHeight}vh - ${CAROUSEL_ITEM_PADDING}vh)`,
                    transition: {
                        ease: NIKE_EASE,
                        duration: DEFAULT_TRANSITION_DURATION,
                    },
                }}
                exit={{
                    width: `${CAROUSEL_ITEM_MEDIA_WIDTH}vh`,
                    height: `${CAROUSEL_VARIANT_1_SETTINGS.mediaHeight}vh`,
                    x: `${CAROUSEL_ITEM_PADDING}vh`,
                    y: '-100vh',
                    transition: {
                        ease: NIKE_EASE,
                        duration: DEFAULT_TRANSITION_DURATION,
                    },
                }}
            >
                <SectionMedia media={media}/>
            </motion.div>
        </VariantWrapper>
    )
}

export default SectionLayoutVariant1;
